import { Component, OnInit, ViewChild } from '@angular/core';
import { UxService } from '~/app/core/services/ux.service';
import { Link } from '~/app/open-age/core/structures';
import { NavService } from '~/app/core/services';
import { ActivatedRoute } from '@angular/router';
import { AppointmentDetailsComponent } from '~/app/open-age-ng/welcome/appointment-details/appointment-details.component';
import { AppointmentsService } from '~/app/open-age/welcome/services';
import { Appointment } from '~/app/open-age/welcome/models/appointment.model';
import { PatientReportService } from '~/app/open-age/telepain/services/patient-report.service';
import * as moment from 'moment-timezone';
import { getTimezone, Timezone } from 'countries-and-timezones';
import { MatDialog } from '@angular/material';
import { Entity } from '~/app/open-age/core/models';
import { JournalListComponent } from '~/app/open-age-ng/insight/journal-list/journal-list.component';

@Component({
  selector: 'app-appointment-view',
  templateUrl: './appointment-view.component.html',
  styleUrls: ['./appointment-view.component.css']
})
export class AppointmentViewComponent implements OnInit {

  isProcessing: boolean;
  id: string;
  isCurrent = true;
  page: Link;
  appointment: Appointment
  timeZone = "America/Los_Angeles"
  timeZoneObj: Timezone
  isExpired = false
  name = ''
  isPatientMatch: string

  @ViewChild('details')
  details: AppointmentDetailsComponent;
  reportType: any;

  entity: Entity

  @ViewChild('journalDetails')
  journalDetails: JournalListComponent;

  constructor(
    public dialog: MatDialog,
    private navService: NavService,
    private route: ActivatedRoute,
    private service: AppointmentsService,
    private reportService: PatientReportService,
    private uxService: UxService
  ) {
    this.timeZoneObj = getTimezone(this.timeZone)
  }

  ngOnInit() {
    this.page = this.navService.register(`/appointment/list/view`, this.route, (isCurrent, params) => {
      this.isCurrent = isCurrent;
      if (this.isCurrent) {
        this.setContext();
      }
      if (params.get("id")) {
        this.id = params.get("id")
      }
    });
    this.isProcessing = true
    this.service.get(this.id).subscribe(item => {
      this.appointment = new Appointment(item)
      this.timeZone = this.appointment.timezone.toString()
      this.timeZoneObj = getTimezone(this.timeZone)
      this.entity = new Entity({
        id: this.appointment.id,
        type: "appointment attendance"
      })
      if (this.appointment.status == 'expired' || this.appointment.status == 'visited') {
        this.isExpired = true
      } else {
        this.isExpired = false
      }
      this.isProcessing = false
    }, err => {
      this.isProcessing = false
    })
  }

  setContext() {
  }

  download() {
    let utcOffset = this.timeZoneObj.utcOffset
    if (moment.tz(this.appointment.from, this.timeZoneObj.name).isDST()) {
      utcOffset = this.timeZoneObj.dstOffset
    }
    this.details.download(Number(utcOffset) / 60, this.timeZoneObj.name)
  }

  back() {
    this.navService.goto("/appointment/list")
  }

  reports() {
    this.reportService.create({ appointmentId: this.appointment.id, time: Number(this.timeZoneObj.utcOffset) / 60 }).subscribe(() => {
      this.uxService.showInfo('Generating Report.')
    })
  }

  onResetJournal() {
    this.journalDetails.refresh()
  }

}
